<!--
    Summary:
        hkml.exhibition.web - p4-y-dna-test4
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-p4-y-dna-test4" title="p4-y-dna-test4">
    <p>
      {{$t('YDnaTest.p4_content_1')}}
    </p>
    <p>
      {{$t('YDnaTest.p4_content_2')}}
    </p>
  </div>
</template>

<script>
  export default {
    name: "p4-y-dna-test4"
  }
</script>


<style scoped lang="scss">
  .en .v-y-dna-test .v-p4-y-dna-test4{
    padding: 10vw 28vw 1.75vw 8vw;
    p:first-child{
      margin-bottom: 5vw;
    }
  }
</style>
<style scoped lang="scss">
  .v-p4-y-dna-test4 {
    text-align: left;

    background: url("../../../assets/images/projects/y-dna-test/p4.jpg");
    background-size: 100% 100%;
    padding: 10vw 47vw 5vw 8vw;
    font-size: 1.70vw;
    line-height: 3.13vw;

    p:first-child{
      margin-bottom: 8vw;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/y-dna-test/p4-y-dna-test4.vue